import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { ASSETS } from "../../utils/config";
import "../TimedWheel/timedwheel.scss";
import Hotbar from "./hotbar";
import LinkIcon from "./icons/Frame 572.svg";
import Videos from "./icons/media.svg";

import RenderLegend from "./renderLegend";
import RenderMedia from "./renderMedia";

function ViewWheelRightSideBar({ Links, starred_list, normal_list }) {
  const [isCategoryListOpen, setIsCategoryListOpen] = useState(false);
  const [isArchiveListExpanded, setIsArchiveListExpanded] = useState(false);
  const [isHotbarVisible, setIsHotbarVisible] = useState(false);

  // const { values: formikValues } = useFormikContext();

  const [starredList, setStarredList] = useState([]);
  const [normalLinks, setNormalLinks] = useState([]);

  useEffect(() => {
    setStarredList(starred_list);
    setNormalLinks(normal_list);
  }, [starred_list, normal_list]);

  const values = Links;

  const toggleCategoryListOpen = () => {
    setIsCategoryListOpen(!isCategoryListOpen);
    setIsViewLinksOpen(false);
    setIsViewMediaOpen(false);
  };

  const [isViewMediaOpen, setIsViewMediaOpen] = useState(false);

  const toggleViewMediaOpen = () => {
    setIsViewMediaOpen(!isViewMediaOpen);
    setIsCategoryListOpen(false);
    setIsViewLinksOpen(false);
  };

  const toggleHotbarOpen = () => {
    setIsHotbarVisible((prevState) => !prevState);
  };
  const toggleViewLinksOpen = () => {
    setIsViewLinksOpen(!isViewLinksOpen);
    setIsCategoryListOpen(false);
    setIsViewMediaOpen(false);
  };

  const [isViewLinksOpen, setIsViewLinksOpen] = useState(false);

  const renderLinkItem = (data, isArchived = false) => {
    return (
      <div
        style={{
          display: "flex",
          marginBottom: "4px",
          justifyContent: "space-between",
          alignItems: "center",
          border: "1px solid #E1E1E1",
          borderRadius: "20px",
          padding: "4px 8px 4px 8px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <div>
            {/* {starredList.some((e) => e === data) ? (
              <StarRateRoundedIcon
                // onClick={() => handleUnStar(data)}
                style={{ color: "#F5CC3B", fontSize: "15px" }}
                size="small"
              />
            ) : (
              <StarOutlineRoundedIcon
                // onClick={() => handleStar(data)}
                style={{ fontSize: "15px" }}
                size="small"
              />
            )} */}
          </div>

          <Typography
            variant="subtitle2"
            component="subtitle2"
            onClick={() => window.open(data, "_blank")}
            style={{
              fontFamily: "DM Sans",
              fontWeight: "200",
              textDecoration: "underline",
              color: "#0058B8",
              cursor: "pointer",
              fontSize: "10px",
              marginTop: "4px",
              marginLeft: "3px",
            }}
          >
            {data.slice(0, 26)}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div style={{ textAlign: "end" }}>
        {isViewLinksOpen ? null : (
          <img
            onClick={toggleViewLinksOpen}
            src={LinkIcon}
            alt="icon"
            style={{
              height: "55px",
              width: "60px",
              position: "relative",
              left: "-1%",
              cursor: "pointer",
            }}
          />
        )}

        {isViewLinksOpen ? (
          <>
            <div style={{ height: !isViewLinksOpen && "0px" }}>
              <div
                onClick={toggleViewLinksOpen}
                style={{
                  height: "40px",
                  width: "30px",
                  borderRadius: "10px",
                  backgroundColor: "#123051",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  right: "18vw",
                  zIndex: 1,
                  cursor: "pointer",
                  marginTop: 10,
                }}
              >
                <ChevronRightIcon
                  fontSize="medium"
                  style={{ color: "white" }}
                />
              </div>
              <div
                className={`categoryList ${isViewLinksOpen ? "open" : ""}`}
              ></div>
            </div>
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "10px",
                width: "18vw",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  style={{
                    fontFamily: "DM Sans",
                    fontWeight: "700",
                    marginLeft: "5px",
                    fontSize: "16px",
                  }}
                >
                  Link Hotbar
                </Typography>
              </div>
              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "50vh",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <StarRateRoundedIcon
                    style={{
                      color: "#F5CC3B",
                      fontSize: "20px",
                      marginLeft: "5px",
                    }}
                    size="medium"
                  />
                  <Typography
                    variant="subtitle1"
                    component="subtitle1"
                    style={{
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                      marginLeft: "5px",
                      fontSize: "12px",
                    }}
                  >
                    Starred Links
                  </Typography>
                </div>

                <div
                  style={{
                    backgroundColor: "#f6f7f9",
                    borderRadius: "10px",
                    padding: "10px",
                    borderLeft: "10px solid #EFAC00",
                    marginTop: "10px",
                    overflowY: "auto",
                  }}
                >
                  {starredList?.length > 0 ? (
                    starredList.map((data) => renderLinkItem(data))
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        fontFamily: "DM Sans",
                        fontSize: "10px",
                      }}
                    >
                      Not Starred Items
                    </div>
                  )}
                </div>
                <div style={{ textAlign: "initial", marginTop: "20px" }}>
                  <img
                    src={ASSETS.linksIcon}
                    alt="icon"
                    style={{ height: "22px", width: "22px" }}
                  />
                  <Typography
                    variant="subtitle1"
                    component="subtitle1"
                    style={{
                      fontFamily: "DM Sans",
                      fontWeight: "500",
                      fontSize: "12px",
                      marginLeft: "7px",
                      marginRight: "30px",
                      marginTop: "20px",
                    }}
                  >
                    Links Overview
                  </Typography>
                </div>
                <div
                  style={{
                    backgroundColor: "#f6f7f9",
                    borderRadius: "10px",
                    padding: "10px",
                    borderLeft: "10px solid #123051",
                    marginTop: "10px",
                  }}
                >
                  {normalLinks?.length > 0 ? (
                    normalLinks.map((data) => renderLinkItem(data))
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        fontFamily: "DM Sans",
                        fontSize: "10px",
                      }}
                    >
                      Not Available
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : null}
      </div>

      {/* View Media  */}

      <div style={{ textAlign: "end" }}>
        {isViewMediaOpen ? null : (
          <img
            onClick={toggleViewMediaOpen}
            src={Videos}
            alt="icon"
            style={{
              height: "55px",
              width: "60px",
              position: "relative",
              left: "-1%",
              marginTop: "14px",
              cursor: "pointer",
            }}
          />
        )}
      </div>
      {isViewMediaOpen ? (
        <RenderMedia
          images={values.images}
          videos={values.videos}
          audios={values.audios}
          documents={values.documents}
          isViewMediaOpen={isViewMediaOpen}
          toggleViewMediaOpen={toggleViewMediaOpen}
          toggleHotbarOpen={toggleHotbarOpen}
        />
      ) : null}

      {/* <div style={{ textAlign: "end" }} onClick={toggleCategoryListOpen}>
        {isCategoryListOpen ? null : (
          <img
            src={ASSETS.legendIcon}
            alt="icon"
            style={{
              height: "90px",
              width: "60px",
              position: "relative",
              left: "-1%",
              cursor: "pointer",
            }}
          />
        )}
      </div> */}
      {isHotbarVisible ? (
        <Hotbar
          images={values.images}
          videos={values.videos}
          audios={values.audios}
          documents={values.documents}
        />
      ) : null}
      {/* 
      {isCategoryListOpen ? (
        <RenderLegend
          isCategoryListOpen={isCategoryListOpen}
          toggleCategoryListOpen={toggleCategoryListOpen}
          categoryData={categoryData}
        />
      ) : null} */}
    </div>
  );
}

export default ViewWheelRightSideBar;
